import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  isInteger(value: any): boolean {
    if (isNaN(value)) {
      return false;
    } else if (parseFloat(value) !== parseInt(value)) {
      return false;
    }
    return true;
  }

  isDecimal(value: any): boolean { 
    if (isNaN(value)) {
      return false;
    } else if (parseFloat(value) !== parseInt(value)) {
      return false;
    }
    return true;
  }

  parseToInteger(value: string | number): number {
    let result: number = null;
    if (value) {
      let str = value.toString();
      if (str.length > 0) {
        result = parseFloat(str) * 100;
      }
    }
    return result;
  }

  parseToDecimal(value: string | number): any {
    let result: string = null;
    if (value) {
      let str = value.toString();
      if (str.length > 0) {
        result = (parseFloat(str) / 100).toFixed(2);
      }
    }
    return result;
  }

}
